export const BACKDROP_ROWS_COUNT = 4;
export const DEBOUNCE_DURATION = 1000;
export const DEFAULT_PAGE_SIZE = 10;
export const INFINITE_SCROLL_PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 30];
